import { Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // const { UserNo } = useAppSelector((state) => state.user);
  // const location = useLocation();
  // const { setUserPathHistory } = useLog(UserNo);

  // useEffect(() => {
  //   setUserPathHistory({
  //     screenName: location.pathname,
  //   });
  // }, [location.pathname]);

  return <Outlet />;
};

export default ProtectedRoute;
